export const getters = {
  // 未读消息数量
  messageUnreadNum(state) {
    return state.messageUnreadNum;
  }
};
